/**
 * 时间计算工具
 */
import dayjs, { Dayjs, ManipulateType } from 'dayjs';
import 'dayjs/locale/zh';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(isoWeek);
export function setDayjsLocale(locale) {
  dayjs.locale(locale);
}

/**
 * 获取时间格式化方法
 * @param picker
 */

export const getTimeDefaultFormat = function () {
  let picker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  if (picker === true || picker === 'HMS') {
    return 'HH:mm:ss';
  } else if (picker === 'HM') {
    return 'HH:mm';
  }
};

/**
 * 获取格式化方法
 * @param picker
 * @param showTime
 * @param locale
 */

// 只展示 日

export const getDefaultFormat = function () {
  let picker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'date';
  let showTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const formatMap = {
    year: 'YYYY',
    month: 'YYYY[-]MM',
    date: 'YYYY[-]MM[-]DD',
    M: 'MM',
    MD: 'MM[-]DD',
    D: 'DD'
  };
  let _format = formatMap[picker];
  if (showTime) {
    const timeFormat = getTimeDefaultFormat(showTime);
    _format = _format + " ".concat(timeFormat);
  }
  return _format;
};

/**
 * utc时间转本地时间
 * @param t
 * @param opts
 */

export const utc2local = (t, opts) => {
  const {
    format,
    picker = 'date',
    showTime = true,
    isUtcTimeZone
  } = opts || {};
  let _format = getDefaultFormat(picker, showTime);
  if (format) {
    _format = format;
  }
  if (!!t) {
    if (isUtcTimeZone) {
      return dayjs.utc(t).format(_format);
    }
    return dayjs.utc(t).local().format(_format);
  }
  return '';
};
export const defaultUtcFormat = 'YYYY-MM-DD[T]HH:mm:ss[Z]';

/**
 * 时间转utc时间
 * @param t
 * @param opts
 */
export const time2utc = (t, opts) => {
  if (!!t) {
    return dayjs.utc(t).format((opts === null || opts === void 0 ? void 0 : opts.format) || defaultUtcFormat);
  }
  return '';
};

/**
 * utc时间fromNow
 * @param t
 *
 * 范围	                         键	                 输出结果
 * 0 to 44 seconds	             s	                 几秒钟前
 * 45 to 89 seconds	             m	                 一分钟前
 * 90 seconds to 44 minutes	     mm	                 2分钟前…44分钟前
 * 45 to 89 minutes	             h	                 一个小时前
 * 90 minutes to 21 hours	       hh	                 2小时前…21小时前
 * 22 to 35 hours	               d	                 一天前
 * 36 hours to 25 days	         dd	                 两天前…25天前
 * 26 to 45 days	               M	                 一个月前
 * 46 days to 10 months	         MM	                 两个月前…10个月前
 * 11 months to 17months	       y	                 一年前
 * 18 months+	                   yy	                 两年前…20年前
 */

export const fromNow = (t, options) => {
  return !!t ? dayjs.utc(t).local().fromNow(options === null || options === void 0 ? void 0 : options.disableAgo) : '';
};
export { Dayjs, ManipulateType };
export default dayjs;